/**
 * Validates an email address using a regular expression
 * @param emailAddress - The email address to validate
 * @returns true if the email is valid, false otherwise
 */
export const validateEmail = (emailAddress: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(emailAddress);
};
